import React, { useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import config from "../coreFIles/config";
import { adminForgotPassword, adminResetPassword } from "../Action/action";

const ForgetPassword = () => {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState({
    newPassword: false,
    confirmPassword: false,
  });
  const [validationError, setValidationError] = useState({});
  const [isDisabled, setIsDisabled] = useState(false);
  const [step, setStep] = useState("email");

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setIsDisabled(true);

    if (!email.trim()) {
      setValidationError({ emailError: "Email is required." });
      setIsDisabled(false);
      return;
    }
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setValidationError({ emailError: "Please enter a valid email address." });
      setIsDisabled(false);
      return;
    }

    try {
      toast.dismiss();
      const res = await adminForgotPassword({ email: email.trim() });
      if (!res.status) {
        toast.error(res.msg);
        setIsDisabled(false);
        return;
      }
      toast.success(res.msg);
      setStep("reset");
      setIsDisabled(false);
    } catch (error) {
      toast.error("Something went wrong");
      setIsDisabled(false);
    }
  };

  const handleResetSubmit = async (e) => {
    e.preventDefault();
    setIsDisabled(true);
    const errors = {};

    if (code.length !== 6) {
      errors.codeError = "Enter the 6-digit email code.";
    }
    if (!newPassword) {
      errors.newPasswordError = "New password is required.";
    } else if (
      newPassword.length < 8 ||
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])/.test(newPassword)
    ) {
      errors.newPasswordError =
        "Use 8+ characters with upper, lower, number, and symbol.";
    }
    if (confirmPassword !== newPassword) {
      errors.confirmPasswordError = "Passwords do not match.";
    }

    if (Object.keys(errors).length) {
      setValidationError(errors);
      setIsDisabled(false);
      return;
    }

    try {
      toast.dismiss();
      const res = await adminResetPassword({
        email: email.trim(),
        code,
        newPassword,
        confirmPassword,
      });
      if (!res.status) {
        toast.error(res.msg);
        setIsDisabled(false);
        return;
      }
      toast.success(res.msg);
      setTimeout(() => {
        window.location.href = `${config.baseUrl}`;
      }, 1500);
    } catch (error) {
      toast.error("Something went wrong");
      setIsDisabled(false);
    }
  };

  const fieldError = (name) =>
    validationError[name] ? (
      <div className="text-danger small mt-1">{validationError[name]}</div>
    ) : null;

  return (
    <div className="hold-transition theme-primary bg-img">
      <div className="container h-p100">
        <Toaster />
        <div className="row align-items-center justify-content-md-center h-p100">
          <div className="col-12">
            <div className="row justify-content-center g-0">
              <div className="col-lg-5 col-md-5 col-12">
                <div className="rounded10 shadow-lg admin-login">
                  <div className="content-top-agile p-20 pb-0">
                    <center className="loginLogo">
                      <img
                        src="images/logo/logo_new.png"
                        alt="logo"
                        style={{ width: "100px" }}
                      />
                    </center>
                    <h2 className="text-white" style={{ fontWeight: "600" }}>
                      {step === "email" ? "Forgot password" : "Reset password"}
                    </h2>
                    <p className="mb-0">
                      {step === "email"
                        ? "Enter your admin email to receive a reset code."
                        : "Enter the email code and choose a new password."}
                    </p>
                  </div>
                  <div className="p-40">
                    {step === "email" ? (
                      <form autoComplete="off" onSubmit={handleEmailSubmit}>
                        <div className="form-group mb-3">
                          <div className="input-group">
                            <span className="input-group-text">
                              <i className="ti-user" />
                            </span>
                            <input
                              type="email"
                              autoComplete="off"
                              className={`form-control ps-15 ${validationError.emailError ? "is-invalid" : ""}`}
                              placeholder="Please enter email"
                              value={email}
                              onChange={(e) => {
                                setEmail(e.target.value);
                                setValidationError({});
                                setIsDisabled(false);
                              }}
                            />
                          </div>
                          {fieldError("emailError")}
                        </div>
                        <div className="row">
                          <div className="col-12 text-center">
                            <button
                              type="submit"
                              style={{ border: "1px solid #e1b02880" }}
                              className="btn btn-primary mt-10"
                              disabled={isDisabled}
                            >
                              {isDisabled ? "Sending..." : "SEND CODE"}
                            </button>
                          </div>
                          <div className="col-12 text-center mt-3">
                            <a href={`${config.baseUrl}`}>Back to sign in</a>
                          </div>
                        </div>
                      </form>
                    ) : (
                      <form autoComplete="off" onSubmit={handleResetSubmit}>
                        <input
                          type="text"
                          name="fake-email"
                          autoComplete="username"
                          tabIndex={-1}
                          aria-hidden="true"
                          style={{ position: "absolute", left: "-9999px", height: 0, width: 0, opacity: 0 }}
                        />
                        <input
                          type="password"
                          name="fake-password"
                          autoComplete="current-password"
                          tabIndex={-1}
                          aria-hidden="true"
                          style={{ position: "absolute", left: "-9999px", height: 0, width: 0, opacity: 0 }}
                        />
                        <div className="form-group mb-3">
                          <div className="input-group">
                            <span className="input-group-text">
                              <i className="ti-mobile" />
                            </span>
                            <input
                              type="text"
                              inputMode="numeric"
                              autoComplete="off"
                              className={`form-control ps-15 ${validationError.codeError ? "is-invalid" : ""}`}
                              placeholder="Email code"
                              value={code}
                              onChange={(e) => {
                                setCode(e.target.value.replace(/\D/g, "").slice(0, 6));
                                setValidationError((prev) => ({
                                  ...prev,
                                  codeError: "",
                                }));
                                setIsDisabled(false);
                              }}
                            />
                          </div>
                          {fieldError("codeError")}
                        </div>
                        <div className="form-group mb-3">
                          <div className="input-group passfield">
                            <span className="input-group-text py-2" style={{ minHeight: "38px" }}>
                              <i className="ti-lock" />
                            </span>
                            <input
                              type={showPassword.newPassword ? "text" : "password"}
                              autoComplete="new-password"
                              className={`form-control ps-15 ${validationError.newPasswordError ? "is-invalid" : ""}`}
                              placeholder="New password"
                              value={newPassword}
                              onChange={(e) => {
                                setNewPassword(e.target.value);
                                setValidationError((prev) => ({
                                  ...prev,
                                  newPasswordError: "",
                                }));
                                setIsDisabled(false);
                              }}
                            />
                            <button
                              className="input-group-text password-toggle"
                              onClick={() =>
                                setShowPassword((prev) => ({
                                  ...prev,
                                  newPassword: !prev.newPassword,
                                }))
                              }
                              type="button"
                            >
                              <i className={`fa ${showPassword.newPassword ? "fa-eye" : "fa-eye-slash"}`} />
                            </button>
                          </div>
                          {fieldError("newPasswordError")}
                        </div>
                        <div className="form-group mb-3">
                          <div className="input-group passfield">
                            <span className="input-group-text py-2" style={{ minHeight: "38px" }}>
                              <i className="ti-lock" />
                            </span>
                            <input
                              type={showPassword.confirmPassword ? "text" : "password"}
                              autoComplete="new-password"
                              className={`form-control ps-15 ${validationError.confirmPasswordError ? "is-invalid" : ""}`}
                              placeholder="Confirm password"
                              value={confirmPassword}
                              onChange={(e) => {
                                setConfirmPassword(e.target.value);
                                setValidationError((prev) => ({
                                  ...prev,
                                  confirmPasswordError: "",
                                }));
                                setIsDisabled(false);
                              }}
                            />
                            <button
                              className="input-group-text password-toggle"
                              onClick={() =>
                                setShowPassword((prev) => ({
                                  ...prev,
                                  confirmPassword: !prev.confirmPassword,
                                }))
                              }
                              type="button"
                            >
                              <i className={`fa ${showPassword.confirmPassword ? "fa-eye" : "fa-eye-slash"}`} />
                            </button>
                          </div>
                          {fieldError("confirmPasswordError")}
                        </div>
                        <div className="row">
                          <div className="col-12 text-center">
                            <button
                              type="submit"
                              style={{ border: "1px solid #e1b02880" }}
                              className="btn btn-primary mt-10"
                              disabled={isDisabled}
                            >
                              {isDisabled ? "Saving..." : "RESET PASSWORD"}
                            </button>
                          </div>
                          <div className="col-12 text-center mt-3">
                            <button
                              type="button"
                              className="btn btn-link p-0"
                              onClick={() => {
                                setStep("email");
                                setCode("");
                                setNewPassword("");
                                setConfirmPassword("");
                                setValidationError({});
                              }}
                            >
                              Resend code
                            </button>
                          </div>
                        </div>
                      </form>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
